<template>
  <div v-if="content" class="tabs-component">
    <div class="tabs">
      <ul class="tabs-header">
        <li
          :class="active === i ? 'active' : ''"
          @click="active = i"
          v-for="(item,i) in content.items"
          :key="item.uid"
        >
          <h3>
            <fai v-if="item.icon" class="icon" :icon="getIcon(item.icon.icon)"></fai>
            <span v-html="item.title"></span>
          </h3>
        </li>
      </ul>
      <div class="tabs-container">
        <ul :style="getStyle(content.items.length)" class="tabs-list">
          <li v-for="item in content.items" :key="item.uid">
            <h2 v-html="item.title"></h2>
            <component
              :key="i"
              v-for="(blok, i) in item.items"
              :content="blok"
              :is="blok.component"
            ></component>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      active: 0,
      hash: this.$route.hash.replace("#", "")
    };
  },
  methods: {
    getStyle(len) {
      return {
        height: len * 100 + "%",
        transform: `translateY(-${(this.active * 100) / len}%)`
      };
    },
    getIcon(icon) {
      return icon.slice(3);
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
$tabs-color: #e7ecea;
$tabs-color-D: #dee3e1;
$grey: #666;
.tabs-component {
  background-color: #fff;
  width: $content-width;
  max-width: $max-width;
  margin: 1em auto;
}
.tabs {
  display: flex;
  justify-content: center;
  .tabs-header {
    display: grid;
    grid-gap: 1px;
    background-color: $tabs-color-D;
    border: darken($tabs-color, 30%);
    > li {
      grid-column: span 1;
      text-align: center;
      cursor: pointer;
      position: relative;
      max-height: 70px;
      h3 {
        padding: 10px 10px;
        background-color: darken($tabs-color, 5%);
        color: grey;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;

        font-family: "Luckiest Guy", cursive;
        span {
          font-size: 15px;
          white-space: nowrap;
        }
        .icon {
          font-size: 30px;
          margin-bottom: 10px;
        }
      }
      &.active {
        &::after {
          content: "";
          position: absolute;
          left: 0;
          height: 100%;
          bottom: 0;
          top: 0;
          width: 5px;
          background-color: $primary;
        }
        h3 {
          background-color: $tabs-color;
          color: $primary;
        }
      }
    }
  }
  .tabs-container {
    overflow: hidden;
    width: 100%;
    background-color: $tabs-color;
    max-height: 600px;
    > ul {
      display: flex;
      transition: transform 0.4s;
      align-items: center;
      flex-direction: column;
      justify-content: space-around;
      > li {
        padding: 20px 25px;
        flex-shrink: 1;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        max-height: 600px;
        h2 {
          text-align: center;
          font-family: "Luckiest Guy", cursive;
          color: $primary;
        }
        p {
        }
        img {
          width: 30%;
          margin: auto;
        }
      }
    }
  }
}

@media screen and (max-width: 980px) {
  .tabs .tabs-header {
    li {
      max-width: 150px;
      overflow: hidden;
      h3 {
        padding: 10px 5px;
        height: 100%;
        span {
          font-size: 12px;
          white-space: pre-line;
        }
        .icon {
          font-size: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .tabs .tabs-header {
    li {
      h3 {
        padding: 8px 25px;
        span {
          display: none;
        }
        .icon {
          font-size: 19px;
        }
      }
    }
  }
}
</style>
